/** @jsxImportSource @emotion/react */
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { useFormContext } from "react-hook-form";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { FormRow } from "../../../common/hook-form/index";
import {
  FileUploadFormat,
  FileUploadInput,
} from "../../../../components/forms/inputs/FileUploadInput";
import { Tabs } from "../../../../components/Tabs";
import { BaseUploadPreview } from "../../../../components/BaseUploadPreview";
import { css } from "@emotion/react";
import { TextInput } from "../../../../components/forms/inputs/TextInput";

const containerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CtaImageSection = () => {
  const { watch, setValue } = useFormContext();

  return (
    <CardContainer>
      <PageHeader
        title="Call to action image"
        subtitle="Enter the image URL of the call to action. Will appear in the right side of the call to action."
      ></PageHeader>
      <CardBody>
        <Tabs
          tabs={["Upload", "Link"]}
          tabPanels={[
            <div css={containerStyle}>
              {watch("imageUrl") && (
                <BaseUploadPreview type="image" url={watch("imageUrl")} />
              )}
              <FileUploadInput
                onDrop={() => setValue("imageUrl", "")}
                accept={FileUploadFormat.IMAGE}
              />
            </div>,
            <FormRow>
              <TextInput
                name="imageUrl"
                onChange={() => {
                  setValue("files", []);
                }}
              />
            </FormRow>,
          ]}
        />
      </CardBody>
    </CardContainer>
  );
};
